import * as React from 'react'
import { PreviewComponentType } from './types'

type PreviewerContextType = {
  previewComponent: PreviewComponentType | null
  setPreviewComponent?: React.Dispatch<React.SetStateAction<PreviewComponentType | null>>
  formIsDirty?: boolean
  setFormIsDirty?: React.Dispatch<React.SetStateAction<boolean>>
}

export const PreviewerContext = React.createContext<PreviewerContextType>({
  previewComponent: null,
  setPreviewComponent: () => null,
  formIsDirty: false
})

export const usePreviewerContext = () => React.useContext(PreviewerContext)

const PreviewerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [previewComponent, setPreviewComponent] = React.useState<PreviewComponentType | null>(null)
  const [formIsDirty, setFormIsDirty] = React.useState<boolean>(false)

  return (
    <PreviewerContext.Provider
      value={{
        previewComponent,
        setPreviewComponent,
        formIsDirty,
        setFormIsDirty
      }}
    >
      {children}
    </PreviewerContext.Provider>
  )
}

export default PreviewerProvider
